import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { IPHONE_DEVICES, MAC_DEVICES, WINDOWS_DEVICES } from "./constants";
import { IosShare, MoreOne, SanaCashLogo } from "assets/Icon";
import { useEffect, useMemo, useState } from "react";

import InstallingInstructions from "./InstallingInstructions";
import primaryLogo from "assets/logo/primaryLogo.png";
import secondaryLogo from "assets/logo/secondaryLogo.png";
import infoLogo from "assets/logo/infoLogo.png";
import primaryTypographyLogo from "assets/logo/primaryTypographyLogo.png";
import secondaryTypographyLogo from "assets/logo/secondaryTypographyLogo.png";

function InstallPwa({ onClick, hideShadow = false }) {
  const theme = useTheme();
  const userPlatform = window.navigator.platform;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, []);

  const getUserDeviceType = useMemo(() => {
    const platformIsWindows = WINDOWS_DEVICES.includes(userPlatform);
    const platformIsMac = MAC_DEVICES.includes(userPlatform);
    const platformIsIos = IPHONE_DEVICES.includes(userPlatform);

    if (platformIsWindows) return "windows";
    else if (platformIsMac) return "mac";
    else if (platformIsIos) return "ios";
    else return "android";
  }, [userPlatform]);

  const stepsToInstall = {
    ios: [
      <>
        ۱- در سافاری بر روی گزینه‌ی <IosShare color={theme.palette.text.main} />{" "}
        کلیک کنید.
      </>,
      "۲- در منوی باز شده، در قسمت پایین، گزینه Add to Home Screen را انتخاب کنید.",
      "۳- در مرحله بعد در قسمت بالا روی Add بزنید.",
    ],
    windows: [
      "۱- در نوار بالا بر روی آیکن Install کلیک کنید.",
      "۲- در پاپ آپ باز شده بر روی Install کلیک کنید.",
    ],
    mac: [
      "۱- بر روی گزینه‌ی Install در نوار جستجوی مرورگر کلیک کنید.",
      "۲- بر روی دکمه‌ی Install در صفحه‌ی باز شده کلیک کنید.",
    ],
    android: [
      <>
        ۱- از منوی مرورگر بر روی <MoreOne color={theme.palette.text.main} />{" "}
        کلیک کنید
      </>,
      "۲- در منوی باز شده گزینه‌ی Add to Home screen را انتخاب کنید.",
      "۳- گزینه‌ی Add را در صفحه‌ی باز شده انتخاب کنید.",
    ],
  };

  const logoTypographyTheme = useMemo(() => {
    const logoObject = {
      primary: primaryTypographyLogo,
      secondary: secondaryTypographyLogo,
      info: primaryTypographyLogo,
    }
    
    return logoObject[theme.mode]
    
  },[theme])

  const logoTheme = useMemo(() => {
    const logoObject = {
      primary: primaryLogo,
      secondary: secondaryLogo,
      info: infoLogo,
    }
    
    return logoObject[theme.mode]
    
  },[theme])

  return (
    <Container>
      <Grid container>
        <MainBox hideShadow={hideShadow}>
          <LogoWrapper>
            <Box pb={2}>
              <img className="main-logo" src={logoTheme} alt="" />
            </Box>

            <img className="text-logo" src={logoTypographyTheme} alt="primaryTypographyLogo" />
          </LogoWrapper>

          <Typography
            dir="rtl"
            textAlign="center"
            color="text.main"
            variant="h4"
          >
            وب اپلیکیشن سانا را دانلود کنید.
          </Typography>

          <Box mt={2}>
            <Typography
              variant="h6"
              textAlign="right"
              color="text.main"
              dir="rtl"
            >
              راهنمای نصب:
            </Typography>

            <InstallingInstructions steps={stepsToInstall[getUserDeviceType]} />
          </Box>

          <Box mt={3}>
            <Button
              fullWidth
              color="success"
              disabled={loading}
              onClick={() => {
                setLoading(true);
                onClick();
              }}
            >
              متوجه شدم
            </Button>
          </Box>
        </MainBox>
      </Grid>
    </Container>
  );
}

const MainBox = styled(Box)(({ theme, hideShadow }) => ({
  maxWidth: "450px",
  width: "100%",
  margin: "auto",
  background: theme.palette.background.paper,
  borderRadius: "8px",
  boxShadow: !hideShadow && theme.shadows[1],
  padding: !hideShadow && theme.spacing(1, 6, 5),

  [theme.breakpoints.down("sm")]: {
    margin: "auto",
    borderRadius: "8px 8px 0 0",
    justifyContent: "center",
    padding: theme.spacing(2, 2, 4),
  },
}));

const LogoWrapper = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(2),
  svg: { width: "130px" },
  ".main-logo": {
    display: "block",
    width: "60px",
    height: "auto",
    objectFit: "contain",
    margin: "auto",
  },

  ".text-logo": {
    display: "block",
    width: "120px",
    auto: "120px",
    objectFit: "contain",
    margin: "auto",
  },
}));

export default InstallPwa;
